<template>
    <div>
        <vx-card>
            <div slot="no-body" class="tabs-container px-6 pt-6">
                <!-- Content Row -->
                <div class="vx-row">
                    <div class="vx-col md:w-1/3 w-full mt-2">
                        <label class="vs-input--label">{{ $t('navMenu.meetingName') }}</label>
                        <span class="text-danger">*</span>
                        <vs-input class="w-full" v-model="meetingRoomInfo.reservationName"
                                  v-validate="'required'" name="reservationName"/>
                        <span class="text-danger text-sm">{{ errors.first('reservationName') }}</span>
                    </div>
                    <div class="vx-col md:w-1/3 w-full mt-2">
                        <label class="vs-input--label">{{ $t('navMenu.meeting') }}</label>
                        <span class="text-danger">*</span>
                        <v-select class="" v-model="meetingRoomInfo.roomId" :clearable="false"
                                  :options="meetingRoomOptions"
                                  v-validate="'required'" name="meetingRoom">
                            <span slot="no-options"> {{ $t('menuOrganization.noOption') }} </span>
                        </v-select>
                        <span class="text-danger text-sm">{{ errors.first('meetingRoom') }}</span>
                    </div>
                    <div class="vx-col md:w-1/3 w-full mt-2">
                        <label class="vs-input--label">{{ $t('navMenu.capacity') }}</label>
                        <span class="text-danger">*</span>
                        <vs-input class="w-full" v-model="meetingRoomInfo.capacity"
                                  name="numberPeople" type="number" min="0" @input="watchCapacity(meetingRoomInfo.capacity)"  v-validate="'required|max:2|min:1'" onkeypress="return event.charCode >= 48 && event.charCode <= 57"/>
                        <span class="text-danger text-sm">{{ errors.first('numberPeople') }}</span>
                    </div>
                    <div class="vx-col md:w-1/3 w-full mt-2">
                        <label class="vs-input--label">{{ $t('navMenu.purpose') }}</label>
                        <span class="text-danger">*</span>
                        <vs-input class="w-full" v-model="meetingRoomInfo.purpose"
                                  v-validate="'required'" name="purpose"/>
                        <span class="text-danger text-sm">{{ errors.first('purpose') }}</span>
                    </div>

                    <div class="vx-col md:w-1/3 w-full mt-2">
                        <label class="vs-input--label">{{ $t('navMenu.meetingDate') }}</label>
                        <span class="text-danger">*</span>
                        <datepicker :format="'dd/MM/yyyy'" v-model="meetingRoomInfo.dateBegin" :highlighted="highlightedFn"
                                    :disabledDates="disabledDatePast"
                                    @input="watchDateBegin(meetingRoomInfo.dateBegin)"
                                    data-vv-validate-on="input" v-validate="'required'" name="dateBegin"></datepicker>
                        <span class="text-danger text-sm">{{ errors.first('dateBegin') }}</span>
                    </div>

                    <div class="vx-col lg:w-1/6 md:w-1/2 w-1/2 mt-2">
                        <label class="vs-input--label">{{ $t('navMenu.startTime') }}</label>
                        <span class="text-danger">*</span>
                        <v-select :value="meetingRoomInfo.fromHourString" :clearable="false" :options="timeSpans"
                                  @input="fromHour => updateTimeSpan(meetingRoomInfo, fromHour, 'fromHour')"
                                  name="fromHour"
                                  v-validate="'required'">
                            <span slot="no-options"> {{ $t('menuOrganization.noOption') }} </span>
                        </v-select>
                        <span class="text-danger text-sm">{{ errors.first('fromHour') }}</span>
                    </div>

                    <div class="vx-col lg:w-1/6 md:w-1/2 w-1/2 mt-2">
                        <label class="vs-input--label">{{ $t('navMenu.endTime') }}</label>
                        <span class="text-danger">*</span>
                        <v-select :value="meetingRoomInfo.toHourString" :clearable="false" :options="timeSpansTo"
                                  @input="toHour => updateTimeSpan(meetingRoomInfo, toHour, 'toHour')" name="toHour"
                                  v-validate="'required'">
                            <span slot="no-options"> {{ $t('menuOrganization.noOption') }} </span>
                        </v-select>
                        <span class="text-danger text-sm">{{ errors.first('toHour') }}</span>
                    </div>

                    <div  class="vx-col lg:w-1/2 md:w-1/2 w-1/2 mt-5 multiEmployee" style="min-width: 65%">
                        <label class="vs-input--label">{{ $t('navMenu.participants') }}</label>
                        <span class="text-danger">*</span>
                        <multiselect v-if="!allEmployee"
                            name="participants"
                            :show-labels="false"
                             group-values="libs"
                             group-label="language"
                            :preselect-first="false"
                            :selectLabel="null"
                            :selectGroupLabel="null"
                            :group-select="true"
                            data-vv-validate-on="input"
                            v-model="meetingRoomInfo.participants"
                            :options="employeeOptions"
                            :searchable="true"
                            :deselectLabel="null"
                            :selectedLabel="null"
                            :multiple="true"
                            :close-on-select="false"
                            tag-position="bottom"
                            :allow-empty="true"
                            :placeholder="$t('navMenu.selectAttendees')"
                            label="fullName"
                            track-by="id"
                            v-validate="'required'"
                            :clearable="false"
                        >
                            <span slot="noResult">{{ $t('menuOrganization.noOption') }}. </span>
                        </multiselect>
                        <span class="text-danger text-sm">{{ errors.first('participants') }}</span>

                    </div>

                </div>
                <!-- Save & Reset Button -->
                <div class="vx-row">
                    <div class="vx-col w-full">
                        <div class="mt-8 flex flex-wrap items-center justify-end mb-5">
                            <vs-button class="ml-auto mt-2" @click="saveChanges" :disabled="!validateForm">{{
                                    $t('button.create')
                                }}
                            </vs-button>
                            <vs-button class="ml-4 mt-2" type="border" color="warning" @click="listMeetingRoom">{{ $t('button.back') }}
                            </vs-button>
                        </div>
                    </div>
                </div>
            </div>
        </vx-card>
    </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>

import vSelect from 'vue-select'
import Datepicker from 'vuejs-datepicker';
import utils from "../../../components/utils";
import Multiselect from 'vue-multiselect';
import moment from 'moment';
export default {
    components: {
        vSelect,
        Datepicker,
        Multiselect
    },
    data() {
        return {
            highlightedFn: {
                customPredictor(date) {
                    if (moment(new Date()).format('YYYY-MM-DD') == moment(new Date(date)).format('YYYY-MM-DD')) {
                        return true;
                    }
                }
            },
            allEmployee: false,
            user_data: null,
            activeTab: 0,
            meetingRoomInfo: {},
            meetingRoomList: [],
            timeSpans: [],
            timeSpansTo: [],
            meetingRoomOptions: [],
            selectedMeetingRoomValue: null,
            employeeOptions: [
                {
                    language: 'Tất cả',
                    libs: []
                }
            ],
            disabledDatePast: {
                customPredictor(date) {
                    const dateString = moment(date).format('YYYY-MM-DD')
                        if (dateString < moment(new Date()).format('YYYY-MM-DD'))  {
                        return true;
                    }
                }
            },
        }
    },
    async created() {
        let dateNow = moment(new Date()).format('HH:mm');
        let dateDayNow = moment(new Date()).format('YYYY-MM-DD');
        let timeDuration = 30, timeSpans = [], timeSpansTo = [];
        for (let i = 0; i < 24 * 60; i = i + timeDuration) {
            if (dateNow < utils.minuteToHour(i - 30) && dateDayNow) {
                timeSpansTo.push({value: i, label: utils.minuteToHour(i)});
            }
            if (dateNow < utils.minuteToHour(i) && dateDayNow) {
                timeSpans.push({value: i, label: utils.minuteToHour(i)});
            }
        }
        this.timeSpans = timeSpans;
        this.timeSpansTo = timeSpansTo;

        //Get Employee
        this.$vs.loading();
        this.$crm.get('/phonebook').then((response) => {
            this.employeeOptions[0].libs = response.data.map(item => {
                return {
                    employeeCode: item.employeeCode,
                    fullName: item.fullName,
                    id: item.employeeId,
                }
            });
            this.$vs.loading.close();
        }).catch((err) => {
            this.$vs.loading.close();
            return this.$vs.notify({
                text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
            });
        });

        this.$vs.loading();
        this.$crm.get('/meeting-room/get').then((response) => {
            this.meetingRoomOptions = response.data.filter(t => t.status != 0).map(item => {
                return {
                    value: item.id,
                    label: item.name,
                }
            });
            this.$vs.loading.close();
        }).catch((err) => {
            this.$vs.loading.close();
            return this.$vs.notify({
                text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
            });
        });
    },
    computed: {
        roomId: {
            get() {
                return {
                    label: this.getMeetingRooms(this.selectedMeetingRoomValue),
                    value: this.selectedMeetingRoomValue
                }
            },
            set(obj) {
                this.selectedMeetingRoomValue = obj.value;
            }
        },
        validateForm() {
            return !this.errors.any()
        }
    },
    methods: {
        watchAllEmployee(event){
            if(event == true){
                this.meetingRoomInfo.participants = this.employeeOptions;
            }
            if(event == false){
                this.meetingRoomInfo.participants = []
            }
        },
        watchDateBegin(date){
            let handlerDate = moment(new Date(date)).format('YYYY-MM-DD')
            if(date) {
                let dateNow = moment(new Date()).format('HH:mm');
                let dateDayNow = moment(new Date()).format('YYYY-MM-DD');
                let timeDuration = 30, timeSpans = [], timeSpansTo = [];
                for (let i = 0; i < 24 * 60; i = i + timeDuration) {
                    if (dateNow < utils.minuteToHour(i - 30) && (dateDayNow == handlerDate)) {
                        timeSpansTo.push({value: i, label: utils.minuteToHour(i)});
                    }
                    if (dateNow < utils.minuteToHour(i) && (dateDayNow == handlerDate)) {
                        timeSpans.push({value: i, label: utils.minuteToHour(i)});
                    }
                    if ((dateDayNow !== handlerDate)) {
                        timeSpansTo.push({value: i, label: utils.minuteToHour(i)});
                        timeSpans.push({value: i, label: utils.minuteToHour(i)});
                    }
                }
                this.timeSpans = timeSpans;
                this.timeSpansTo = timeSpansTo;
            }

        },
        watchCapacity(number){
            if(number.length == 1 && number == 0) {
               this.meetingRoomInfo.capacity = 1
            }
            if(number.length >= 3) {
                return this.$vs.notify({
                    title: 'Có lỗi sảy ra!',
                    text: 'Số người tham dự phải nhỏ hơn 100 người !',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })
            }
        },
        getMeetingRooms(id) {
            let meetingRoom = this.meetingRoomOptions.find(x => x.value == id);
            return (meetingRoom && meetingRoom.label) || 'Chưa xác định';
        },
        updateTimeSpan(setting, hour, type) {

            setting[type] = hour.value;
            setting[`${type}String`] = hour.label;
        },
        async saveChanges(evt) {
            evt.preventDefault();
            try {
                if (!this.validateForm) return;
                const result = await this.$validator.validateAll();
                if (!result) return;
                {
                    let dateconver = this.meetingRoomInfo.dateBegin.toLocaleDateString('en-US') + ' ' + this.meetingRoomInfo.fromHourString + ':00';
                    let dateendconver = this.meetingRoomInfo.dateBegin.toLocaleDateString('en-US') + ' ' + this.meetingRoomInfo.toHourString + ':00';
                    let dateBegins = new Date(Date.parse(dateconver));
                    let dateEnds = new Date(Date.parse(dateendconver));
                    let checkDate = false;
                    if (dateBegins >= dateEnds) {
                        checkDate = true;
                        return this.$vs.notify({
                            text: 'Chọn khoảng thời gian không phù hợp',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    }
                    if (checkDate) return;
                    let url = `/reservation/book`
                    const payload = {
                        capacity: this.meetingRoomInfo.capacity,
                        dateBegin: dateBegins.toISOString(),
                        dateEnd: dateEnds.toISOString(),
                        employeeId: null,
                        purpose: this.meetingRoomInfo.purpose,
                        reservationName: this.meetingRoomInfo.reservationName,
                        roomId: this.meetingRoomInfo.roomId.value,
                        participants: this.meetingRoomInfo.participants,
                    }
                    this.$vs.loading();
                    this.$crm.post(url, payload).then((res) => {
                        if (res.status == 204) {
                            this.$vs.notify({
                                color: 'danger',
                                text: `Cuộc họp đã bị trùng, vui lòng đặt lại cuộc họp`,
                                iconPack: 'feather',
                                icon: 'icon-alert-circle',
                            });
                        }
                        if (res.status == 201) {
                            this.$vs.notify({
                                color: 'success',
                                text: `Thêm cuộc họp thành công`,
                                iconPack: 'feather',
                                icon: 'icon-alert-circle',
                            });
                            this.$router.push(`/user/manage-multipurpose-room`).catch(() => {
                            })
                        }
                        this.$vs.loading.close();

                    }).catch((err) => {
                        this.$vs.loading.close();
                        return this.$vs.notify({
                            text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        });
                    });
                }
            } catch (ex) {
                console.log(ex);
            }
        },
        listMeetingRoom() {
            this.$router.push(`/user/meeting-schedule${this.meetingRoomInfo.organizationBranchId ? `?branch_id=${this.meetingRoomInfo.organizationBranchId}` : ''}`).catch(() => {
            })
        }
    },
}
</script>

<style lang="scss">
.multiEmployee{
    .multiselect__content-wrapper{
        max-height: 200px !important;
    }
}
</style>
